import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'person_matches',
    viewPath: props.viewPath,
  })

  return function onClick() {
    return submit({ type: 'cancel' })
  }
}
